export default {
  banner: {
    title: "You only pay for",
    "title-other": "",
    MAU: "MAUs",
    "section-one": {
      title: "Free program",
      button: "Start Building with Authing",
      descript: "Up to 3000 free API calls.",
    },
    "section-two": {
      title: "Complex scene？",
      button: "Talk with an Expert",
      descript: "From today on, your success is our success.",
    },
  },
  priceList: {
    alsoInclude: "Also Include:",
    MAU: "MAUs",
    "month-unit": "month",
    "year-unit": "year",
    unit: "",
    "contact-us": "Contact Us",
    "common-tip":
      "Any user authenticated in a single user pool during a month.",
    payway: {
      month: "Monthly payment",
      year: "Annual payment",
      "comment-one":
        "Subscription for one year is free of charge for two months. Unlike other vendors, authing charges only ",
      "comment-two": "",
    },
    develop: {
      freeText: "All Free Features",
      title: "Developer",
      "num-unit": "month",
      comment: "1,000 MAUS",
      fun: {
        item1: {
          text: "Social Connections",
          comment:
            "Authing supports every popular social site, e.g. such as WeChat, Weibo, and GitHub, and can work with any IdP compatible with OAuth2 or OIDC.",
        },
        item2: {
          text: "Up to 3 Days Log Retention",
          comment:
            "Longer storage of log data to meet compliance requirements or to facilitate diagnosis and resolution of authentication issues, and forensic analysis. ",
        },
        item3: {
          text: "User Management Dashboard",
          comment:
            "User interface tools to help administrators manage user identities including password resets, creating and provisioning, blocking and deleting users. Authing includes a powerful user management dashboard built on top of the platform's advanced APIs.",
        },
        item4: {
          text: "Role and Access Management",
          comment:
            "Effective user management with the ability to create groups and permissions and deliver granular access control.",
        },
        item5: {
          text: "Customizable sign-in widgets, domains, email",
          comment:
            'A native "login box" user interface for web applications and single-page applications using popular frameworks. This box is an intuitive, easy and attractive authentication widget that can be styled to reflect your brand, and that supports all the user-accessible capabilities of Authing without additional coding.',
        },
      },
    },
    developPro: {
      freeText: "All Developer Pro Features",
      title: "Developer Pro",
      "num-unit": "month",
      comment: "500 MAUS",
      fun: {
        item1: {
          text: "2 Enterprise Connections",
          comment:
            "Enterprise IdPs supporting protocols like SAML, DingTalk, and WeCom (among others) to authenticate your users.",
        },
        item2: {
          text: "Up to 10 Days Log Retention",
          comment:
            "Longer storage of log data to meet compliance requirements or to facilitate diagnosis and resolution of authentication issues, and forensic analysis. ",
        },
        item3: {
          text: "Unlimited Social Connections",
          comment:
            "Authing supports every popular social site, e.g. such as WeChat, Weibo, and GitHub, and can work with any IdP compatible with OAuth2 or OIDC.",
        },
        item4: {
          text: "Employee Identity",
          comment:
            "An internal employee of your company that authenticated with any connection or identity provider.",
        },
        item5: {
          text: "Delegated Admin",
          comment:
            "Enable stricter access control to the Authing dashboard for different admin users for role-based access control by limiting the exposure to identity configuration.",
        },
        item6: {
          text: "Basic Multi-factor Authentication",
          comment:
            "Authing Verify is a powerful Multi Factor Authentication (MFA) tool that generates one-time passwords to very your users. It lives as a WeChat MiniProgram so that users do not need to download it.",
        },
        item7: {
          text: "Private Cloud Service（Add-on）",
          comment:
            "A low-friction, dedicated Authing deployment model for enhanced performance, security, and compliance over our standard Public Cloud offering. Customers have the option to host private instances on their infrastructure. ",
        },
        item8: {
          text: "Workforce Single Sign-On Integration",
          comment:
            "Quick and easy integration with your existing application ecosystem.",
        },
        item9: {
          text: "Service level agreement SLA",
          comment: "Authing commitment to end user availability",
        },
      },
    },
    enterprise: {
      freeText: "All Enterprise Features",
      title: "Enterprise",
      fun: {
        item1: {
          text: "Unlimited Enterprise Connections",
          comment:
            "Authing supports every popular social site, e.g. such as WeChat, Weibo, and GitHub, and can work with any IdP compatible with OAuth2 or OIDC.",
        },
        item2: {
          text: "Up to 30 Days Log Retention",
          comment:
            "Longer storage of log data to meet compliance requirements or to facilitate diagnosis and resolution of authentication issues, and forensic analysis. ",
        },

        item3: {
          text: "Private Cloud Service",
          comment:
            "A low-friction, dedicated Authing deployment model for enhanced performance, security, and compliance over our standard Public Cloud offering. Customers have the option to host private instances on their infrastructure. ",
        },
        item4: {
          text: "Unlimited Social Connections",
          comment:
            "Authing supports every popular social site, e.g. such as WeChat, Weibo, and GitHub, and can work with any IdP compatible with OAuth2 or OIDC.",
        },
        item5: {
          text: "Workforce Single Sign-On Integration",
          comment:
            "Quick and easy integration with your existing application ecosystem.",
        },
        item6: {
          text: "Single Sign On Launchpad",
          comment:
            "Authing launchpad is the front door to all the applications. Once the user is in, he will see a custom dashboard tailored to have all the applications IT has assigned to him. Single click on one and the user is automatically logged in. No need to re-enter any credentials.",
        },
        item7: {
          text: "Service level agreement SLA",
          comment: "Authing commitment to end user availability",
        },
        item8: {
          text: "Response in 30 Minutes",
          comment:
            "Due to the defects of Authing, the priority will determine the time and nature of the response.",
        },
        item9: {
          text: "Custom Development Support Engineer",
          comment:
            "Authing supports customized solutions for customers and product capability customization.",
        },
        item10: {
          text: "Phone / Meeting Support",
          comment:
            "5x8 hour instant after-sales support: telephone / conference, exclusive service group support.",
        },
        item11: {
          text: "Training / Support Engineer",
          comment:
            "Including manual docking support services, including troubleshooting and necessary remote assistance to ensure smooth docking.",
        },
        item12: {
          text: "Customer Support Manager",
          comment:
            "Exclusive account manager communicates the best solution and outputs the best practice.",
        },
      },
    },
  },
  guide: {
    title: "Build or Buy: an assessment guide for identity management",
    subtitle:
      "What is identity management? Should we build or buy? Download free Authing eBook",
    button: "Download E-Books",
  },
  compare: {
    title: "Functional Comparison",
    develop: "Developer",
    "develop-pro": "Developer Pro",
    enterprise: "Enterprise",
    authentication: {
      title: "Authentication",
      feature1: {
        title: "Customer Identity",
        tip:
          "Any user that authenticated during a given month for a given user pool.",
        "list-one": "Up to 50K MAUs",
        "list-two": "Up to 50K MAUs",
        "list-three": "As many as you need",
      },
      feature2: {
        title: "Social Connections",
        tip:
          "Authing supports every popular social site, e.g. such as WeChat, Weibo, and GitHub, and can work with any IdP compatible with OAuth2 or OIDC.",
        "list-one": "Unlimited",
        "list-two": "Unlimited",
        "list-three": "Unlimited",
      },
      feature3: {
        title: "Employee Identity",
        tip:
          "An internal employee of your company that authenticated with any connection or identity provider.",
        "list-one": "",
        "list-two": "Up to 50K employees",
        "list-three": "As many as you need",
      },
      feature4: {
        title: "Enterprise Connections",
        tip:
          "Enterprise IdPs supporting protocols like SAML, AD, LDAP, DingTalk, and WeCom (among others) to authenticate your users.",
        "list-one": "",
        "list-two": "2 connections",
        "list-three": "Unlimited",
      },
    },
    userManagement: {
      title: "User Management",
      feature1: {
        title: "Log Retention",
        tip:
          "Longer storage of log data to meet compliance requirements or to facilitate diagnosis and resolution of authentication issues, and forensic analysis. ",
        "list-one": "Up to 3 Days",
        "list-two": "Up to 10 Days",
        "list-three": "Up to 30 Days",
      },
      feature2: {
        title: "User Management Dashboard",
        tip:
          "User interface tools to help administrators manage user identities including password resets, creating and provisioning, blocking and deleting users. Authing includes a powerful user management dashboard built on top of the platform's advanced APIs.",
        "list-one": "checked",
        "list-two": "checked",
        "list-three": "checked",
      },
      feature3: {
        title: "Role and Access Management",
        tip:
          "Effective user management with the ability to create groups and permissions and deliver granular access control.",
        "list-one": "checked",
        "list-two": "checked",
        "list-three": "checked",
      },
      feature4: {
        title: "Delegated Admin",
        tip:
          "Enable stricter access control to the Authing dashboard for different admin users for role-based access control by limiting the exposure to identity configuration.",
        "list-one": "",
        "list-two": "checked",
        "list-three": "checked",
      },
    },
    security: {
      title: "Security",
      feature1: {
        title: "SMS One-time Passwords",
        tip:
          "An alternative to using username / password credentials to authenticate a user. Authing currently supported one-time passwords delivered by SMS message.",
        "list-one":
          "  Free 300 SMS Messages / month,  Add-On 0.079 RMB / message",
        "list-two":
          "  Free 1,500 SMS Messages / month,  Add-On 0.079 RMB / message",
        "list-three":
          "  Free 12,000 SMS Messages / month,  Add-On 0.079 RMB / message",
      },
      feature2: {
        title: "Basic Multi-factor Authentication",
        tip:
          "Authing Verify is a powerful Multi Factor Authentication (MFA) tool that generates one-time passwords to very your users. It lives as a WeChat MiniProgram so that users do not need to download it. ",
        "list-one": "",
        "list-two": "checked",
        "list-three": "checked",
      },
    },
    enterprisePersonal: {
      title: "Enterprise Personalization",
      feature1: {
        title: "Customizable sign-in widgets, domains and email templates",
        tip:
          'A native "login box" user interface for web applications and single-page applications using popular frameworks. This box is an intuitive, easy and attractive authentication widget that can be styled to reflect your brand, and that supports all the user-accessible capabilities of Authing without additional coding.',
        "list-one": "checked",
        "list-two": "checked",
        "list-three": "checked",
      },
      feature2: {
        title: "Email Customizations",
        tip:
          "Templates and configuration parameters to allow you to customize the look and feel and sender identities of emails sent by Authing as part of authentication workflows.",
        "list-one": "checked",
        "list-two": "checked",
        "list-three": "checked",
      },
      feature3: {
        title: "Private Cloud Service (annual contract required)",
        tip:
          "A low-friction, dedicated Authing deployment model for enhanced performance, security, and compliance over our standard Public Cloud offering. Customers have the option to host private instances on their infrastructure. ",
        "list-one": "",
        "list-two": "Add-on (29,999 RMB/yr)",
        "list-three": "Included",
      },
      feature4: {
        title: "Workforce Single Sign-On Integration",
        tip:
          "Quick and easy integration with your existing application ecosystem.",
        "list-one": "",
        "list-two": "checked",
        "list-three": "checked",
      },
      feature5: {
        title: "Custom Development Support Engineer",
        tip: "",
        "list-one": "",
        "list-two": "799 RMB/man-hour",
        "list-three": "20% Discount",
      },
      feature6: {
        title: "Single Sign On Launchpad",
        tip:
          "Authing launchpad is the front door to all the applications. Once the user is in, he will see a custom dashboard tailored to have all the applications IT has assigned to him. Single click on one and the user is automatically logged in. No need to re-enter any credentials.",
        "list-one": "",
        "list-two": "",
        "list-three": "checked",
      },
    },
    support: {
      title: "Enterprise Support",
      feature1: {
        title: "Support Availability",
        "list-one": "12/5",
        "list-two": "12/5",
        "list-three": "24/7/365",
      },
      feature2: {
        title: "Customer Support",
        "list-one": "Response in 24 Hours",
        "list-two": "Response in 1 Hour",
        "list-three": "Response in 30 Minutes",
      },
      feature3: {
        title: "WeChat/Slack Support",
        "list-one": "checked",
        "list-two": "checked",
        "list-three": "checked",
      },
      feature4: {
        title: "SLA",
        "list-one": "",
        "list-two": "99.9%",
        "list-three": "99.99%",
      },
      feature5: {
        title: "Training / Support Engineer",
        "list-one": "",
        "list-two": "699 RMB/man-hour",
        "list-three": "20% Discount",
      },
      feature6: {
        title: "Phone / Meeting Support",
        "list-one": "",
        "list-two": "",
        "list-three": "checked",
      },
      feature7: {
        title: "Customer Support Manager",
        "list-one": "",
        "list-two": "",
        "list-three": "1 Manager",
      },
    },
  },
  question: {
    title: "Common Problem",
    subtitle:
      "We're here to explain everything you might want to know. Let's help!",
    "item-one": {
      title: "How do I choose Authing technology?",
      descript:
        "How do I choose Authing technology? Please choose the technology you want to use according to your specific situation. Before you start, we recommend that you read this article:",
      link: "Why should all software use single sign-on to manage users?",
    },
    "item-two": {
      title: "How to choose the authentication method?",
      descript:
        "If you do not understand the standard protocols such as OAuth, OIDC, SAML, LDAP and so on, and the application security requirements are not high, it is recommended to use common authentication; if your application security requirements are high, whether you understand the standard protocol or not, please use the standard protocol authentication.",
    },
    "item-three": {
      title: "What is Authing？",
      descript:
        "Authing provides professional authentication and authorization services. We provide developers and businesses with authentication modules needed to secure their applications, which eliminates the need for developers to become security experts. You can connect the application of any platform to Authing (whether it is a newly developed application or an old application), and you can also customize the login method of the application (such as email/password, SMS / verification code, scanning code, etc.). You can choose our SDK or call relevant API to access your application according to the technology you use. When a user initiates an authorization request, Authing will help you authenticate their identity and return the necessary user information to your application.",
    },
    "item-four": {
      title: "Why use Authing？",
      other: "Here are some usage scenarios of Authing:",
      "descript-one":
        "You want to develop a cool program, and you want to add user authentication and authorization. You want your users to use WeChat and GitHub to log in. At the same time, you also want to track the user's registration source and activity data, so that you can make subsequent user growth.",
      "descript-two":
        "You have made an API, and you hope to use the OAuth 2.0 protocol to ensure the security of the API.",
      "descript-three":
        "You have made a lot of applications, and you hope that the user data of these applications can be communicated through single sign-on.",
      "descript-four":
        "You have made a JavaScript front-end application and a mobile application, and you hope that both client applications can access your API safely.",
      link: "Read the document",
    },
  },
};
